import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _isEmpty from 'lodash/isEmpty';

// components
import Btn from '../../components/Btn';

// actions
import { getRoute } from '../../reducers/RouteBtn/actions';

const RouteBtnPropTypes = {
  tripIsValid: PropTypes.bool, // When true the application is ready to create a waypoint
  fields: PropTypes.arrayOf(PropTypes.object).isRequired, // Array of objects containing information about each "place"
  directionsRequested: PropTypes.bool.isRequired, // If the directions have been requested by the user
  label: PropTypes.string.isRequired, // Button label from AEM
  dispatchGetRoute: PropTypes.func.isRequired, // Passes trip details to routing service
  prevState: PropTypes.shape({}).isRequired, // The app state before user began editing their trip details
  vehicle: PropTypes.shape({}).isRequired, // Vehicle information
};

const RouteBtnDefaultProps = {
  tripIsValid: false,
};

class RouteBtn extends Component {
  constructor(props) {
    super(props);

    this.fetchDirections = this.fetchDirections.bind(this);
  }

  fetchDirections() {
    // eslint-disable-next-line object-curly-newline
    const { tripIsValid, fields, vehicle, dispatchGetRoute } = this.props;

    if (tripIsValid) {
      dispatchGetRoute(fields, vehicle);
    }
  }

  render() {
    // eslint-disable-next-line object-curly-newline
    const { directionsRequested, tripIsValid, label, prevState } = this.props;

    if (!directionsRequested) {
      return (
        <div className="route">
          <div className="route__flexbox">
            <Btn
              styles={classNames('route__btn', 'btn-transactional', {
                'route__btn--editing': !_isEmpty(prevState),
              })}
              handleClick={this.fetchDirections}
              disabled={!tripIsValid}
            >
              {label}
            </Btn>
          </div>
        </div>
      );
    }

    return null;
  }
}

RouteBtn.propTypes = RouteBtnPropTypes;
RouteBtn.defaultProps = RouteBtnDefaultProps;

const mapStateToProps = state => ({
  tripIsValid: state.Places.tripIsValid,
  fields: state.Places.fields,
  directionsRequested: state.Directions.directionsRequested,
  label: state.RouteBtn.label,
  prevState: state.App.prevState,
  vehicle: state.Vehicle,
});

const mapDispatchToProps = dispatch => ({
  dispatchGetRoute: (fields, vehicle) => {
    dispatch(getRoute(fields, vehicle));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RouteBtn);
